const stats = {
  1: '出库拣货',
  2: '出库分拣',
  3: '出库打包',
  4: '出库转移'
}
export const columns = [
  {
    title: "批次",
    dataIndex: "pkgCode",
    key: "pkgCode"
  },
  {
    title: "数量",
    dataIndex: "changeNums",
    key: "changeNums"
  },
  {
    title: "类型",
    dataIndex: "bizType",
    key: "bizType",
    customRender: text => {
      return stats[text];
    }
  },
  {
    title: "从库位(容器)",
    dataIndex: "fromContainerCode",
    key: "fromContainerCode"
  },
  {
    title: "到库位(容器)",
    dataIndex: "toContainerCode",
    key: "toContainerCode"
  },
  {
    title: "系统单据",
    dataIndex: "systemOrderNo",
    key: "systemOrderNo"
  },
  {
    title: "业务单据",
    dataIndex: "bizOrderNo",
    key: "bizOrderNo"
  },
  {
    title: "操作人",
    dataIndex: "operatorName",
    key: "operatorName"
  },
  {
    title: "操作时间",
    dataIndex: "createTime",
    key: "createTime"
  },
];
